const updateCanonical = (pathname) => {
  const canonicalTag = document.querySelector('link[rel="canonical"]');

  if (canonicalTag) {
    canonicalTag.setAttribute('href', `${document.location.origin}${pathname}`);
  }
};

export default updateCanonical;
